"use client";

import { type ReactNode, useEffect } from "react";
import { usePathname } from "next/navigation";
import Script from "next/script";
import { TERMLY_WEBSITE_UUID } from "modules/common/constants/termly";

const TERMLY_SCRIPT_SRC = `https://app.termly.io/resource-blocker/${TERMLY_WEBSITE_UUID}`;

interface TermlyCMPProviderProps {
  children: ReactNode;
}

export default function TermlyCMPProvider({
  children,
}: TermlyCMPProviderProps) {
  const pathname = usePathname();
  // Re-initialize Termly on route changes (SPA navigation)
  useEffect(() => {
    window.Termly?.initialize();
  }, [pathname]);

  if (process.env.NODE_ENV === "development") {
    return <>{children}</>;
  }
  return (
    <>
      <Script
        src={TERMLY_SCRIPT_SRC}
        strategy="lazyOnload"
        data-cfasync="false"
        onLoad={() => {
          // Forward Termly consent events as a custom DOM event
          window.Termly?.on("consent", () => {
            window.dispatchEvent(new CustomEvent("termly:consent-change"));
          });

          // Re-evaluate stored consent now that the lazily loaded CMP is ready.
          window.dispatchEvent(new CustomEvent("termly:consent-change"));
        }}
      />
      {children}
    </>
  );
}

export function showCookiePreferences(): void {
  window.displayPreferenceModal?.();
}
